import {LauncherServiceBase} from '../launcher-service-base';
import {IGamesCustomizationService} from './games-customization.service.interface';
import {GameCustomSettings} from '../orbit-configs-storage/configs-storage.service.interface';

const ADDED_GAME_TYPES_KEY = 'orbit.addedGameTypesFromSdm';
const CUSTOMIZED_GAME_TYPES_KEY = 'sdk.Game.customGamesSettings';

export class GamesCustomizationService extends LauncherServiceBase implements IGamesCustomizationService {

    getSelectedGamesFromSdm(): number[] {
        return [...(this.services.configsStorage.getValue(ADDED_GAME_TYPES_KEY) || [])];

    }


    addSdmGame(gameType: number): void {
        let existingGameTypes = this.getSelectedGamesFromSdm();
        let index = existingGameTypes.findIndex(gt => gt === gameType);
        if(index < 0) {
            existingGameTypes.push(gameType)
        }

        this.services.configsStorage.updateValue(ADDED_GAME_TYPES_KEY, existingGameTypes);
        this._preserveBackwardCompatibility(existingGameTypes);
    }

    removeSdmGame(gameType: number): void {
        let existingGameTypes = this.getSelectedGamesFromSdm();
        let index = existingGameTypes.findIndex(gt => gt === gameType);
        if(index < 0) {
            return;
        }

        let customSettings = this.services.configsStorage.getValue(CUSTOMIZED_GAME_TYPES_KEY) || {};
        if(customSettings && customSettings[gameType]) {
            delete customSettings[gameType];
            this.services.configsStorage.updateValue(CUSTOMIZED_GAME_TYPES_KEY, customSettings);
        }

        existingGameTypes.splice(index, 1);

        if(existingGameTypes.length === 0) {
            existingGameTypes = undefined;
        }

        this.services.configsStorage.updateValue(ADDED_GAME_TYPES_KEY, existingGameTypes);
        this._preserveBackwardCompatibility(existingGameTypes);
    }

    private _preserveBackwardCompatibility(gameTypes: number[]) {
        if(gameTypes && gameTypes.length > 0) {
            this.services.configsStorage.updateValue('orbit.gameTypes', gameTypes.join(','));
        } else {
            this.services.configsStorage.resetToDefault('orbit.gameTypes');
        }

    }

    getGameCustomSettings(gameType: number): GameCustomSettings {
        let customSettings = this.services.configsStorage.getValue(CUSTOMIZED_GAME_TYPES_KEY) || {};
        return customSettings[gameType];
    }

    setGameCustomSettings(gameType: number, customGameSettings: GameCustomSettings): void  {
        this.services.configsStorage.updateValue(`${CUSTOMIZED_GAME_TYPES_KEY}.${gameType}`, customGameSettings);
    }

    isGameInCustomizationList(gameType: number): boolean {
        return this.getSelectedGamesFromSdm().findIndex(gt => gt === gameType) >= 0;
    }
}